import { render, staticRenderFns } from "./PlatformSpecific.vue?vue&type=template&id=30f3054c&"
import script from "./PlatformSpecific.vue?vue&type=script&lang=js&"
export * from "./PlatformSpecific.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports